/* ==========================================================================
   LYSORIC COLLECTION INFO — place this file in: assets/lysoric-collection-seo.js
   ========================================================================== */
window.LysoricCollectionSEO = (function () {
  function init(sectionId) {
    var root = document.getElementById('lcs-' + sectionId);
    if (!root || root.dataset.lcsInit) return;
    root.dataset.lcsInit = '1';

    var items = root.querySelectorAll('.lcs-acc-item');

    items.forEach(function (item) {
      var header = item.querySelector('.lcs-acc-header');
      var body = item.querySelector('.lcs-acc-body');
      if (!header || !body) return;

      header.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');

        if (isOpen) {
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () {
            body.style.maxHeight = '0px';
          });
          item.classList.remove('open');
          header.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('open');
          header.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });

      /* keep an open item's height correct if content reflows (e.g. window resize) */
      window.addEventListener('resize', function () {
        if (item.classList.contains('open')) {
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  return { init: init };
})();